import * as React from 'react';
import { sendRemindersAction } from './sendRemindersAction';
import { useDispatch } from 'react-redux';
import { useAppState } from '../../../../core/redux/hooks';
import { raterIsInvited } from '../module';
import { participantRatersAction } from '../participantRatersAction';
import { useMount } from '../../../../core/hooks/useMount';
import { useLoading } from '../../../../core/api/hooks';
import { ActionType } from '../../../../core/redux/actionType';
import { useToggleOnComplete } from '../../../../core/hooks/useToggleOnComplete';


/**
 * Hook returning general Remind Raters state and actions
 */
export const useRemindRaters = (projectId: number, participantId: number) => {
  const dispatch = useDispatch();

  const autoRemindersOn  = useAppState(state => state.projectSummary?.autoReminders);
  const raterInvited     = useAppState(state => state.projectSummary?.raterInvited);
  const sendingReminders = useLoading(ActionType.SendRemindersRequest, `${projectId}`);
  const raters           = useAppState(state => (state.projectRaters || {})[projectId]);

  useMount(
    () => {
      if (!raters) {
        dispatch(participantRatersAction(projectId, participantId));
      }
    },
  );

  const raterArr = Object.values(raters || {});

  const invited = React.useMemo(
    () => raterArr.filter(raterIsInvited).sort((rater1, rater2) => rater2.raterId - rater1.raterId),
    [raterArr],
  );

  const addressesToRemind = React.useMemo(
    () => invited.map(rater => ({ toAddress: rater.email, languageId: rater.languageId })),
    [invited],
  );

  const [remindersSent, toggleRemindersSent] = useToggleOnComplete(ActionType.SendRemindersRequest, `${projectId}`);

  const sendReminders = React.useCallback(
    () => {
      dispatch(sendRemindersAction(projectId, participantId, '', addressesToRemind));
    },
    [addressesToRemind, participantId, projectId, dispatch],
  );

  return { autoRemindersOn, raterInvited, sendingReminders, sendReminders, remindersSent, toggleRemindersSent };
};

